import React, { Component } from 'react'
import styled from 'styled-components'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Col, Row, Collapse } from 'react-bootstrap';
import config from 'react-global-configuration';
import MediaQuery from 'react-responsive';
import moment from 'moment'
import bookingUtils from '../../utils/bookingUtils'
import ReactFitText from 'react-fittext'
import cssVar from '../../styles/variables'

import { GolfCourses, FreeSlots, CalendarCenter, MobileFreeSlots, GolfCourseHeading, WhiteUnderlineHover,CalendarVerticalCenter } from './BookingCalendarStyle'
import { ImageSection, MobileError, Icon, Black, HotelIcon } from '../GeneralStyle'
import { DoubleBounce } from 'better-react-spinkit'

import mailIcon from '../../images/icons/mail_icon.png';
import calIcon from '../../images/icons/calendar_lg_gold.png';
import phoneIcon from '../../images/icons/phone_icon.png';
import hotelIcon from '../../images/icons/hotel_bed.svg'
import creditIcon from '../../images/icons/credits.png'

import LeadingBadgeImage from '../../images/icons/leading_badge.png';

@inject(
  'bookingStore',
  'datesStore',
  'golfCourseStore'
)
@observer
class CalendarRow extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      openError: false,
      errorMessage: ""
    }
    this.bookingUtils = bookingUtils
    this.openChooseDateModal = this.openChooseDateModal.bind(this)
    this.openBookingModal = this.openBookingModal.bind(this)
    this.formatDate = this.formatDate.bind(this)
  }

  openBookingModal(golfCourse, bookings, date) {
    if (this.bookingUtils.performChecks(date, bookings, golfCourse)) {
      this.setState({
        openError: false,
        errorMessage: ""
      })
      this.props.bookingStore.setGolfCourse(golfCourse)
      this.props.bookingStore.setDate(date)
      this.props.bookingStore.setGolfCourseFreeSlots(
        bookings
          ? bookings.freeSlots
          : golfCourse.slots)
    } else {
      let errorMessage = this.bookingUtils.getPerformCheckError()
      this.setState({
        openError: true,
        errorMessage: errorMessage
      })
    }
  }

  openChooseDateModal() {
    this.props.bookingStore.setGolfCourse(this.props.golfCourse)
    this.props.bookingStore.setBookingsPerDate(this.props.bookingsPerDate)
  }

  formatDate(date) {
    return moment(JSON.stringify(date).substr(1, 10)).locale("de").format('dd Do MMMM YYYY')
  }

  render() {
    const { golfCourse, bookingsPerDate } = this.props
    const rowHeight = window.innerWidth < 769 ? "null" : 150

    const bookingSlots = (
      this.props.datesStore.dates.map((date, key) => {
        let isActive = false

        let isLoading = this.props.golfCourseStore.loadedAfter > date

        for(let time of golfCourse.activeTime) {
          const from = new Date(time.from)
          const to = new Date(time.to)
          to.setDate(to.getDate() + 1)

          if(to >= date && date >= from) {
            isActive = true
          }
        }

        return(
          <Col sm={9} md={1} lg={1} key={key} style={{ cursor: "pointer", backgroundColor: (key % 2 === 0 ? false : true) ? "rgb(245, 245, 245)" : "white", height: rowHeight }}>
            <MediaQuery query='(min-width: 224px)'>
              <MediaQuery query='(max-width: 768px)'>
                <CalendarCenter>
                { !isActive ?
                  <MobileFreeSlots>-</MobileFreeSlots>
                  : isLoading ?
                    <MobileFreeSlots>loading</MobileFreeSlots>
                  : bookingsPerDate[JSON.stringify(date).substr(1, 10)]
                    ? (bookingsPerDate[JSON.stringify(date).substr(1, 10)].freeSlots) === 0
                      ? <Row onClick={() => { this.openBookingModal(golfCourse, bookingsPerDate[JSON.stringify(date).substr(1, 10)], JSON.stringify(date).substr(1, 10)) }}>
                        <Col xs={8}>
                          <MobileFreeSlots color={"rgba(255, 96, 97, 0.32)"} style={{ borderRight: "1px solid rgba(0, 0, 0, 0.16)" }}>{this.formatDate(date)}</MobileFreeSlots>
                        </Col>
                        <Col xs={4}>
                          <MobileFreeSlots color={"rgba(255, 96, 97, 0.32)"}>X</MobileFreeSlots>
                        </Col>
                        <div style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.16)", width: "80%", margin: "0 auto" }} />
                      </Row>
                      : <Row onClick={() => { this.openBookingModal(golfCourse, bookingsPerDate[JSON.stringify(date).substr(1, 10)], JSON.stringify(date).substr(1, 10)) }}>
                        <Col xs={8}>
                          <MobileFreeSlots style={{ borderRight: "1px solid rgba(0, 0, 0, 0.16)" }}>{this.formatDate(date)}</MobileFreeSlots>
                        </Col>
                        <Col xs={4}>
                          <MobileFreeSlots color={"#DAB777"}>{bookingsPerDate[JSON.stringify(date).substr(1, 10)].freeSlots}</MobileFreeSlots>
                        </Col>
                        <div style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.16)", width: "80%", margin: "0 auto" }} />
                      </Row>
                    : <Row onClick={() => { this.openBookingModal(golfCourse, bookingsPerDate[JSON.stringify(date).substr(1, 10)], JSON.stringify(date).substr(1, 10)) }}>
                      <Col xs={8}>
                        <MobileFreeSlots style={{ borderRight: "1px solid rgba(0, 0, 0, 0.16)" }}>{this.formatDate(date)}</MobileFreeSlots>
                      </Col>
                      <Col xs={4}>
                        <MobileFreeSlots color={"#DAB777"}>{golfCourse.slots}</MobileFreeSlots>
                      </Col>
                      <div style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.16)", width: "80%", margin: "0 auto" }} />
                    </Row>}
                </CalendarCenter >
              </MediaQuery>
            </MediaQuery>

            <MediaQuery query='(min-width: 768px)'>
              <CalendarCenter>
                { !isActive ?
                  <FreeSlots>-</FreeSlots>
                  : isLoading ?
                    <FreeSlots><SpinnerWrapper><DoubleBounce color={"#DAB777"} size={20}/></SpinnerWrapper></FreeSlots>
                  : bookingsPerDate[JSON.stringify(date).substr(1, 10)]
                    ? (bookingsPerDate[JSON.stringify(date).substr(1, 10)].freeSlots) === 0
                      ? <FreeSlots color={"#ff4e50"}>X</FreeSlots>
                      : <FreeSlots>{bookingsPerDate[JSON.stringify(date).substr(1, 10)].freeSlots} </FreeSlots>
                    : <FreeSlots>{golfCourse.slots}</FreeSlots>}
              </CalendarCenter >
            </MediaQuery>
          </Col >
        )}
      )
    )

    return (
      <div style={{ borderBottom: (window.innerWidth < 769 ? 2 : 1) + "px solid lightgrey", borderColor: "rgba(0,0,0,0.15)" }}>
        <MediaQuery query='(min-width: 768px)'>
          <div onClick={this.openChooseDateModal} style={{ overflow: "hidden" }} className={"nine-cols no-padding-row"}>
            <Col xs={9} sm={2} md={2} lg={2} style={{paddingLeft: 15, paddingRight: 0}}>
              <LazyImageSection background={`${config.get('CLOUDINARY_URL')}c_scale,q_60,w_600/${this.props.golfCourse.calendarPicture}.jpg`}>
                <GolfCourseWrapper>
                  { golfCourse.isLeading && <LeadingBadgeWrapper><img src={ LeadingBadgeImage || '' } /></LeadingBadgeWrapper> }
                  <GolfCourses style={{position: "relative"}}>
                    <CalendarVerticalCenter>
                      <ReactFitText compressor={1.1}>
                      <GolfCourseHeading style={{ textTransform: "uppercase", margin: 5 }}>{golfCourse.shortName}</GolfCourseHeading>
                      </ReactFitText>
                      <i style={{color: 'lightgrey'}}> {golfCourse.price } Credits / Greenfee</i>
                      { golfCourse.hotels.length > 0 &&
                        <Icon size={20} icon={hotelIcon} float={"right"} style={{display: "block", position: "absolute", left: "50%", transform: "translateX(-50%)"}}/>
                      }
                    </CalendarVerticalCenter>
                  </GolfCourses>
                </GolfCourseWrapper>
              </LazyImageSection>
            </Col>
            {bookingSlots}
          </div>
        </MediaQuery>
        <MediaQuery query='(max-width: 768px)'>
          <div style={{ overflow: "hidden" }} className={"nine-cols no-padding-row"}>
            <Col xs={9} sm={2} md={2} lg={2} onClick={() => this.setState({ open: !this.state.open, openError: false })}>
              <LazyImageSection background={`${config.get('CLOUDINARY_URL')}c_scale,q_60,w_400/${this.props.golfCourse.calendarPicture}.jpg`} tabletHeight={ 145 }>
                <GolfCourseWrapper>
                  { golfCourse.isLeading && <MobileLeadingBadgeWrapper><img src={ LeadingBadgeImage || '' } /></MobileLeadingBadgeWrapper> }
                  <GolfCourses style={{position: "relative"}}>
                    <CalendarVerticalCenter>
                      <div>
                      <ReactFitText maxFontSize={18}>
                        <h3 style={{ textTransform: "uppercase", margin: 0 }}>{golfCourse.shortName}</h3>
                      </ReactFitText>
                      <i style={{color: 'lightgrey'}}> {golfCourse.price } Credits / Greenfee</i>
                      { golfCourse.hotels.length > 0 &&
                        <HotelIcon size={20} icon={hotelIcon} float={"right"} style={{float: 'none', margin: '0 auto', marginTop: 10}}/>
                      }
                      </div>
                    </CalendarVerticalCenter>
                  </GolfCourses>
                </GolfCourseWrapper>
              </LazyImageSection>
            </Col>
            <Collapse in={this.state.open}>
              <div style={{ marginTop: 110 }}>
                <div style={{ marginTop: 10, marginBottom: 10 }}>
                  <div style={{ margin: "0 auto", width: 250, marginTop: 8 }}><Icon size={16} icon={phoneIcon} /><WhiteUnderlineHover href={"tel:" + golfCourse.phone} style={{ fontSize: 14, textAlign: "center" }}><Black>{golfCourse.phone}</Black></WhiteUnderlineHover></div>
                  <div style={{ margin: "0 auto", width: 250, marginTop: 8 }}><Icon size={16} icon={calIcon} /> <WhiteUnderlineHover target={"_blank"} href={golfCourse.tournamentCalendar} style={{ fontSize: 14, textAlign: "center" }}><Black>Turnierkalender</Black></WhiteUnderlineHover></div>
                  <div style={{ margin: "0 auto", width: 250, marginTop: 8 }}><Icon size={16} icon={mailIcon} /> <WhiteUnderlineHover href={"mailto:" + golfCourse.email} style={{ fontSize: 14, textAlign: "center" }}><Black>{golfCourse.email}</Black></WhiteUnderlineHover></div>
                  <div style={{ margin: "0 auto", width: 250, marginTop: 8 }}><Icon size={16} icon={creditIcon} /> <p style={{ fontSize: 14, textAlign: "center" }}><Black>{golfCourse.price} Credits / Greenfee</Black></p></div>
                </div>
                {bookingSlots}
              </div>
            </Collapse>
            <Collapse in={this.state.openError}>
              <MobileError onClick={() => this.setState({ openError: false })}>
                {this.state.errorMessage}
              </MobileError>
            </Collapse>
          </div>
        </MediaQuery>
      </div>
    )
  }
}

CalendarRow.propTypes = {
  bookingStore: MobxPropTypes.observableObject,
  datesStore: MobxPropTypes.observableObject
};

export default CalendarRow;

const LeadingBadgeWrapper = styled.div `
  width: 100%;
  background: ${ cssVar.colors.gold };
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 30px;

  img {
    height: 30px;
    width: 100%;
    object-fit: contain;
    object-position: center;
  }
`
const MobileLeadingBadgeWrapper = styled.div `
  width: 100%;
  background: ${ cssVar.colors.gold };
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 30px;

  img {
    height: 20px;
    width: 100%;
    object-fit: contain;
    object-position: center;
  }
`

export const GolfCourseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

const SpinnerWrapper = styled.span `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`

class LazyImageSection extends Component {

  constructor( props ) {
    super(props)

    this.state = {
      src: ''
    }
  }

  componentDidMount() {
    const imageLoader = new Image();
    imageLoader.src = this.props.background

    imageLoader.onload = () => {
      this.setState({ src: this.props.background })
    };
  }

  render() {
    const props = this.props
    return (
      <ImageSection { ...props } background={ this.state.src }>{ this.props.children }</ImageSection>
    )
  }

}



// WEBPACK FOOTER //
// /src/components/internal/CalendarRow.js